import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { LEGAL_POLICIES, POLICY_VERSION, POLICY_EFFECTIVE, SUPPORT_EMAIL, CHANGE_HISTORY } from '../data/legalPolicies';

const OTHER = [['terms', 'Terms'], ['privacy', 'Privacy'], ['refunds', 'Refunds'], ['cookies', 'Cookies'], ['ai-disclaimer', 'AI Disclaimer'], ['acceptable-use', 'Acceptable Use'], ['copyright', 'Copyright']];

export default function LegalPage({ policy }) {
  const doc = LEGAL_POLICIES[policy];
  return <div className="min-h-screen bg-white"><Navbar />
    <SEOHead title={doc.title} description={doc.summary} path={`/${policy}`} />
    <main className="release-main max-w-3xl" data-testid={`legal-page-${policy}`}>
      <h1 className="text-4xl sm:text-5xl font-bold mb-4" data-testid="legal-title">{doc.title}</h1>
      <p className="text-sm text-gray-600 mb-6" data-testid="legal-meta">Version {POLICY_VERSION} · Effective {POLICY_EFFECTIVE} · Operator: LearnixTa · Contact: <a href={`mailto:${SUPPORT_EMAIL}`} className="text-teal-700 underline" data-testid="legal-contact-email">{SUPPORT_EMAIL}</a></p>
      <p className="border-l-4 border-teal-500 bg-teal-50 pl-4 pr-4 py-3 my-6 rounded-r-lg text-gray-800" data-testid="legal-summary"><span className="font-semibold">Summary: </span>{doc.summary}</p>
      {doc.sections.map((s, i) => <section key={s.title} className="my-8" data-testid={`legal-section-${i + 1}`}>
        <h2 className="font-bold text-lg mb-3">{s.title}</h2>
        {s.paras.map((p, j) => <p key={j} className="text-gray-700 mb-3">{p}</p>)}
      </section>)}
      <section className="my-8 border-t border-gray-200 pt-6" data-testid="legal-change-history">
        <h2 className="font-bold text-lg mb-3">Change history</h2>
        <ul className="text-sm text-gray-600 list-disc pl-5">{CHANGE_HISTORY.map(c => <li key={c.version}>v{c.version} · {c.date} — {c.note}</li>)}</ul>
      </section>
      <nav className="flex flex-wrap gap-x-4 gap-y-2 text-sm my-6" aria-label="Other policies" data-testid="legal-other-policies">
        {OTHER.filter(([k]) => k !== policy).map(([k, label]) => <Link key={k} to={`/${k}`} className="text-teal-700 underline underline-offset-4" data-testid={`legal-link-${k}`}>{label}</Link>)}
      </nav>
      <div className="release-actions"><Link to="/contact" className="release-button" data-testid="legal-contact">Contact LearnixTa</Link><Link to="/" data-testid="legal-home">Back to public learning</Link></div>
    </main><Footer /></div>;
}
